export function equipementsToAdapted(items) {
  return items
    ? items.map((item) => {
        return equipementToAdapted(item);
      })
    : null;
}

export function equipementToAdapted(item) {
  return item
    ? {
        equipement_id: item.id,
        equipement_libelle: item.libelle,
        equipement_societe_id: item.societe_id,
      }
    : null;
}

export function adaptedToEquipement(item) {
  return item
    ? {
        libelle: item.equipement_libelle,
      }
    : null;
}
